import { createApp } from 'vue';
import LandingPage from '../components/LocationPage/Index.vue';

import InnerPage from '../components/InnerLocationPage/Index.vue';
import ContactInnerForm from '../components/ContactInnerForm.vue';

const landing = createApp(LandingPage);
landing.mount('#locationpagelist');
const inner = createApp(InnerPage);
inner.mount('#innerlocationpage');
const contactForm = createApp(ContactInnerForm);
contactForm.mount('#contactForm');
